import { render, staticRenderFns } from "./GanttChart.vue?vue&type=template&id=aeae74c2&scoped=true&lang=pug&"
import script from "./GanttChart.vue?vue&type=script&lang=ts&"
export * from "./GanttChart.vue?vue&type=script&lang=ts&"
import style0 from "./GanttChart.vue?vue&type=style&index=0&id=aeae74c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeae74c2",
  null
  
)

export default component.exports